<template>
    <div class="pp-slide-aside">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'pp-slide-aside',
    created: function() {
        if(this.$parent.$options.name === 'pp-container') {
            this.$parent.hasSlideAside = true
        }
    },
}
</script>
